import React, { useState } from "react";
import { ENDPOINT } from "../config";
import { SubmitButton } from "../Components/FormButton";

export function RestoreCompany({ setFeedback, post }) {
  const [companyId, setCompanyId] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const isFormValid = companyId.trim();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    try {
      const response = await post(`${ENDPOINT}/admin/restore-company`, {
        companyId: companyId.trim(),
      });

      if (response.status >= 400 || response.error) {
        setFeedback({
          type: "alert",
          message: `Failed to restore company. Reason: ${response.error}`,
        });
        return;
      }

      setFeedback({
        type: "success",
        message: `Company ${companyId} successfully restored`,
      });
      setCompanyId("");
    } catch (error) {
      setFeedback({
        type: "alert",
        message:
          "Failed to restore company. Please check the ID and try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-2xl shadow-sm overflow-hidden mt-8">
      <div className="bg-gradient-to-r from-[#5D21D2] to-[#2c1c6c] px-6 py-4">
        <div className="flex items-center gap-3">
          <div>
            <h2 className="text-lg font-semibold text-white">
              Restore Deleted Company
            </h2>
            <p className="text-slate-300 text-sm">
              Restore a deleted company and its users
            </p>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="p-6">
        <div className="mb-6">
          <AdminInput
            label="Company ID"
            value={companyId}
            onChange={(e) => setCompanyId(e.target.value)}
            placeholder="Ex: rlr3y2fmevwipi"
          />
        </div>

        {/* Submit Button */}
        <SubmitButton
          isDisabled={!isFormValid}
          isLoading={isSubmitting}
          loadingText="Restoring..."
          text="Restore"
        />
      </form>
    </div>
  );
}

const AdminInput = ({ label, type = "text", value, onChange, placeholder }) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-2">
        {label}
      </label>
      <input
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        style={{
          width: "100%",
          padding: isFocused ? "11px 15px" : "12px 16px",
          border: isFocused ? "2px solid #7c3aed" : "1px solid #e5e7eb",
          borderRadius: "8px",
          fontSize: "14px",
          outline: "none",
          transition: "all 0.2s ease",
          backgroundColor: "white",
        }}
      />
    </div>
  );
};
